import React, { useMemo } from 'react';
import { CustomFieldContext, CustomFieldContextProps, customFieldSlice } from '../context/CustomFieldContext';
import { CustomField } from '../types/custom_field/customField';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';

interface CustomFieldProviderProps {
  children: React.ReactNode;
}

export default function CustomFieldProvider({ children }: CustomFieldProviderProps) {
  const dispatch = useAppDispatch();
  const items = useAppSelector(state => state.customFields.items);
  const loading = useAppSelector(state => state.customFields.loading);

  const customFields = useMemo(() => {
    return new Map(items.map(item => [item.id, new CustomField(item)]));
  }, [items]);

  const customFieldContext: CustomFieldContextProps = {
    customFields,
    customFieldsLoading: loading,
    setCustomFields: (customFields: Map<string, CustomField>) =>
      dispatch(customFieldSlice.actions.setAll([...customFields.values()])),
  };

  return <CustomFieldContext.Provider value={customFieldContext}>{children}</CustomFieldContext.Provider>;
}
